import styled from 'styled-components';

export const Contaniner = styled.div`
	width: 100%;
	ul.ant-menu.ant-menu-root,
	.ant-menu-sub.ant-menu {
		background: rgb(9, 23, 68);

		li.ant-menu-submenu,
		.ant-menu-submenu-title,
		.ant-menu-submenu-arrow,
		li.ant-menu-item .ant-menu-title-content a {
			color: #fff !important;
			&:hover {
				color: #fff !important;
			}
		}
	}
	li.ant-menu-item.ant-menu-item-selected,
	.ant-menu-item.ant-menu-item-only-child.ant-menu-item-selected {
		background: #081744;
	}
`;
